import {confirmBlockToggle} from 'utils/_confirm.js'
import {loadingWindowVisible, loadingWindowHidden} from '4-component/loading/_index.js'

let invoiceDeleteUrl = 0

// export
const deleteBtnHandler = (event) => {
  event.preventDefault()
  console.log('invoiceDelete')
  invoiceDeleteUrl = event.currentTarget.getAttribute('href')
  console.log('invoiceDeleteUrl: ', invoiceDeleteUrl)
  confirmBlockToggle('show')
}


const deleteAction = () => {
  const confirmYes = document.querySelector('.confirm__block .invoice-confirm-button-yes')
  if( confirmYes ) {
    confirmYes.addEventListener('click', (event) => {
      event.preventDefault()
      window.location = invoiceDeleteUrl
      confirmBlockToggle('hide')
      loadingWindowVisible('process', '.page__content')
    })
  }

  const confirmNo = document.querySelector('.confirm__block .invoice-confirm-button-no')
  if( confirmNo ) {
    confirmNo.addEventListener('click', (event) => {
      event.preventDefault()
      invoiceDeleteUrl = ''
      confirmBlockToggle('hide')
    })
  }
}


export {
  deleteBtnHandler,
  deleteAction,
}


